/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageSystemForms } from '../../models/page-system-forms';

export interface GetAllSystemFormsApiV2SystemFormsOrgAllGet$Params {
  org: string;

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getAllSystemFormsApiV2SystemFormsOrgAllGet(http: HttpClient, rootUrl: string, params: GetAllSystemFormsApiV2SystemFormsOrgAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSystemForms>> {
  const rb = new RequestBuilder(rootUrl, getAllSystemFormsApiV2SystemFormsOrgAllGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageSystemForms>;
    })
  );
}

getAllSystemFormsApiV2SystemFormsOrgAllGet.PATH = '/api/v2/system-forms/{org}/all';
